import type { Project } from "@tasduvar/engine";
import { summarize, type ProjectStore, type ProjectSummary } from "./types";

export class MemoryProjectStore implements ProjectStore {
  private m = new Map<string, Project>();
  async list(): Promise<ProjectSummary[]> { return [...this.m.values()].map(summarize).sort((a, b) => b.updatedAt.localeCompare(a.updatedAt)); }
  async load(id: string): Promise<Project | null> { return this.m.get(id) ?? null; }
  async save(p: Project): Promise<void> { this.m.set(p.id, { ...p, updatedAt: new Date().toISOString() }); }
  async remove(id: string): Promise<void> { this.m.delete(id); }
}
